export default __webpack_public_path__ + "static/media/Img0009.ccd16d43.png";